// tslint:disable:max-line-length
import * as React from 'react';
import { SixteenIcon } from '../../ui/icon/icons/16';
import { CianGroupIcon } from '../../ui/icon/icons/cian-group';

const styles = require('./footer.css');

export class FooterComponent extends React.PureComponent {
  public render() {
    const currentYear = new Date().getFullYear();

    return (
      <footer className={styles['footer']}>
        <div className={styles['logo-wrapper']}>
          <CianGroupIcon iconClassName={styles.logo} />
          <p className={styles.leader}>Лидер онлайн-недвижимости России&#42;</p>
        </div>
        <noindex>
          <div className={styles['footer-asterisk']}>
            &#42; по количеству посещений сайта cian.ru пользователями сети Интернет по данным LiveInternet в разделе
            «Недвижимость»
          </div>
        </noindex>
        <div className={styles['links']}>
          <span className={styles['link-wrapper']}>
            <a target="_blank" rel="noreferrer" href="https://www.cian.ru/" className={styles['link']}>
              Cian.ru
            </a>
            &nbsp;— достоверные объявления о&nbsp;продаже и&nbsp;аренде жилой, загородной и&nbsp;коммерческой
            недвижимости
          </span>
          <noindex>
            <span className={styles['link-wrapper']}>
              <a target="_blank" rel="noreferrer" href="http://emls.ru/" className={styles['link']}>
                EMLS.ru
              </a>
              &nbsp;— сайт недвижимости Санкт-Петербурга
            </span>
          </noindex>
        </div>
        <div className={styles.copyright}>
          <span className={styles['copyright-text']}>© {currentYear}, ЦИАН ГРУПП</span>
          <SixteenIcon iconClassName={styles.age} />
        </div>
      </footer>
    );
  }
}

export const Footer = FooterComponent;
